module.exports = __webpack_public_path__ + "img/elo.50cfd43d.png";